(function () {
  'use strict';

  const data = window.refaProductData || {};
  const grid = document.querySelector('.refa-grid');
  const countEl = document.querySelector('.refa-count');
  const breadcrumbEl = document.querySelector('.refa-breadcrumb');
  const titleEl = document.querySelector('.refa-title-wrap h1');

  function collectionHandle() {
    const match = window.location.pathname.match(/\/collections\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function money(value) {
    const amount = Number(value);
    if (!Number.isFinite(amount)) return '';
    return '¥' + Math.round(amount).toLocaleString('ja-JP');
  }

  function imageUrl(product) {
    if (product && product.images && product.images.length) {
      return product.images[0].src || product.images[0];
    }
    if (product && product.image) {
      return product.image.src || product.image;
    }
    return '';
  }

  function productUrl(product) {
    return product.url || '/products/' + product.handle;
  }

  function tagList(product) {
    if (Array.isArray(product.tags)) return product.tags;
    return (product.tags || '').split(',').map(tag => tag.trim()).filter(Boolean);
  }

  function addCategoryGridStyles() {
    if (document.getElementById('tp-category-grid-compact-style')) return;
    const style = document.createElement('style');
    style.id = 'tp-category-grid-compact-style';
    style.textContent = `
      .tp-shop-categories { padding-top: 36px; padding-bottom: 34px; }
      .tp-shop-categories .tp-shop-categories__grid { grid-template-columns: repeat(8, minmax(0, 1fr)) !important; gap: 10px !important; }
      .tp-shop-categories .tp-shop-category-card { border-radius: 5px; }
      .tp-shop-categories .tp-shop-category-card__image { inset: 10px 10px 34px; }
      .tp-shop-categories .tp-shop-category-card__label { min-height: 32px; padding: 0 6px 9px; font-size: 9.5px; letter-spacing: .09em; }
      @media (max-width: 1100px) { .tp-shop-categories .tp-shop-categories__grid { grid-template-columns: repeat(4, minmax(0, 1fr)) !important; } }
      @media (max-width: 760px) { .tp-shop-categories .tp-shop-categories__grid { grid-template-columns: repeat(3, minmax(0, 1fr)) !important; } }
    `;
    document.head.appendChild(style);
  }

  function addCategoryCards() {
    if (collectionHandle() !== 'all') return;
    const gridEl = document.querySelector('.tp-shop-categories__grid');
    if (!gridEl) return;
    addCategoryGridStyles();

    const categories = [
      {
        handle: 'premium-haircare',
        label: 'Hair Care',
        image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/files/andhoney_melty_moist_rich_hair_oil_top_white.png?v=1784725681',
        alt: '&honey Melty Moist Rich Hair Oil',
        bg: '#f3f0ec',
        scale: '0.78'
      },
      {
        handle: 'k-beauty',
        label: 'K Beauty',
        image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/celimax_vita_a_retinal_shot_tightening_booster_gallery_01_top.png?v=1785296717',
        alt: 'K Beauty skincare',
        bg: '#f7f3f5',
        scale: '0.9'
      },
      {
        handle: 'japanese-oral-care',
        label: 'Oral Care',
        image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/3_b14734bc-f1a4-47d9-85c5-7a690f693f18.png?v=1785296786',
        alt: 'Japanese oral care',
        bg: '#f3f6f6',
        scale: '0.9'
      },
      {
        handle: 'starbuks-japan',
        label: 'Starbucks Japan',
        image: 'https://cdn.shopify.com/s/files/1/0640/1468/0107/collections/starbucks-sakura2026-stainless-togo-bottle-airy-blue-473ml_top_white.png?v=1785296958',
        alt: 'Starbucks Japan limited items',
        bg: '#f2f4ef',
        scale: '0.92'
      }
    ];

    const existing = new Set(Array.from(gridEl.querySelectorAll('a[href*="/collections/"]')).map(link => link.getAttribute('href').split('/collections/')[1]));

    categories.forEach(category => {
      if (existing.has(category.handle)) return;
      const card = document.createElement('a');
      card.className = 'tp-shop-category-card';
      card.href = '/collections/' + category.handle;
      card.style.setProperty('--card-bg', category.bg);
      card.style.setProperty('--image-scale', category.scale);
      card.innerHTML = [
        '<span class="tp-shop-category-card__image">',
        '<img src="' + category.image + '" alt="' + category.alt + '" loading="lazy" width="600" height="600">',
        '</span>',
        '<span class="tp-shop-category-card__label">' + category.label + '</span>'
      ].join('');
      gridEl.appendChild(card);
    });
  }

  function filterKeys(product) {
    const keys = new Set();
    const title = (product.title || '').toLowerCase();
    const type = (product.product_type || product.type || '').toLowerCase();
    const vendor = (product.vendor || '').toLowerCase();
    const handleize = value => String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

    if (type) keys.add(handleize(type));
    tagList(product).forEach(tag => {
      keys.add(handleize(tag));
      if (tag.toLowerCase() === 'new') keys.add('new-arrivals');
    });

    if (title.includes('skin') || title.includes('lotion') || title.includes('serum') || title.includes('cream') || title.includes('cleanser') || title.includes('toner') || title.includes('emulsion') || type.includes('skin') || type.includes('facial')) keys.add('skincare');
    if (title.includes('hair') || title.includes('shampoo') || title.includes('treatment') || title.includes('scalp') || title.includes('comb') || type.includes('hair') || type.includes('scalp')) keys.add('haircare');
    if (title.includes('makeup') || title.includes('mascara') || title.includes('eyeliner') || title.includes('blush') || title.includes('powder') || title.includes('primer') || title.includes('lip') || title.includes('nail') || type.includes('makeup')) keys.add('makeup');
    if (title.includes('mask') || type.includes('mask')) keys.add('face-mask');
    if (title.includes('sunscreen') || title.includes('spf') || title.includes('uv') || vendor.includes('anessa') || vendor.includes('biore')) keys.add('sunscreen');
    if (title.includes('refa') || vendor.includes('refa')) {
      keys.add('refa');
      keys.add('beauty-tools');
      keys.add('haircare');
    }
    if (title.includes('love chrome') || vendor.includes('love chrome')) {
      keys.add('love-chrome');
      keys.add('beauty-tools');
      keys.add('haircare');
    }
    if (title.includes('brush') || title.includes('dryer') || title.includes('iron') || title.includes('device') || title.includes('roller') || type.includes('brush')) keys.add('beauty-tools');
    if (title.includes('men') || type.includes('men')) keys.add('mens-beauty');
    if (title.includes('supplement') || title.includes('collagen') || title.includes('vitamin') || title.includes('placenta') || title.includes('protein') || type.includes('supplement')) keys.add('supplement');
    if (title.includes('cle de peau') || title.includes('clé de peau') || title.includes('baum') || title.includes('baobao') || vendor.includes('cle de peau') || vendor.includes('baum')) keys.add('luxury');

    return Array.from(keys).join(' ');
  }

  function renderCard(product) {
    const card = document.createElement('article');
    card.className = 'refa-card';
    card.dataset.product = product.handle;
    card.dataset.category = filterKeys(product);

    const firstVariant = product.variants && product.variants[0] ? product.variants[0] : {};
    const img = imageUrl(product);
    const alt = product.title || '';
    const price = firstVariant.price || product.price || '';

    card.innerHTML = [
      '<div class="refa-thumb">',
      img ? '<img src="' + img + '" alt="' + alt.replace(/"/g, '&quot;') + '" loading="lazy" width="600" height="800">' : '',
      '</div>',
      '<div class="refa-name">' + (product.title || '') + '</div>',
      '<div class="refa-meta"></div>',
      '<div class="refa-price">' + money(price) + '</div>',
      '<button class="refa-quick" type="button">VIEW ITEM</button>'
    ].join('');

    data[product.handle] = Object.assign(data[product.handle] || {}, {
      title: product.title,
      brand: product.vendor,
      price: money(price),
      available: product.available,
      url: productUrl(product),
      desc: product.body_html ? product.body_html.replace(/<[^>]+>/g, '') : '',
      ship: '🚚 Guaranteed delivery 5-14 days, free shipping\n🇯🇵 Direct from Japan, Authentic product',
      stock: product.available ? 'In stock' : 'Out of stock',
      badges: tagList(product).map(tag => tag.toLowerCase()).includes('new') ? ['NEW'] : [],
      images: (product.images || []).map(image => image.src || image),
      specs: [],
      variations: (product.variants || []).map(variant => ({ id: variant.id, label: variant.title }))
    });

    return card;
  }

  async function hydrateCollectionProducts() {
    const handle = collectionHandle();
    if (!grid || !handle) return;

    const existing = new Set(Array.from(grid.querySelectorAll('.refa-card')).map(card => card.dataset.product));
    const response = await fetch('/collections/' + handle + '/products.json?limit=250', { credentials: 'same-origin' });
    if (!response.ok) return;

    const payload = await response.json();
    const products = payload.products || [];
    products.forEach(product => {
      if (!existing.has(product.handle)) {
        grid.appendChild(renderCard(product));
        existing.add(product.handle);
      }
    });
  }

  function getFilterLabel(control) {
    const clone = control.cloneNode(true);
    clone.querySelectorAll('span').forEach(span => span.remove());
    return clone.textContent.trim();
  }

  function cards() {
    return Array.from(document.querySelectorAll('.refa-card'));
  }

  function filterControls() {
    return Array.from(document.querySelectorAll('.refa-side li[data-filter], .refa-mobile-filters button[data-filter]'));
  }

  function updateFilterCounts() {
    const allCards = cards();
    filterControls().forEach(control => {
      const filter = control.dataset.filter;
      const count = filter === 'all'
        ? allCards.length
        : allCards.filter(card => (card.dataset.category || '').split(' ').includes(filter)).length;
      const span = control.querySelector('span');
      if (span) span.textContent = count;
      if (filter !== 'all') control.hidden = count === 0;
    });
    if (countEl) countEl.textContent = allCards.length + (allCards.length === 1 ? ' item' : ' items');
  }

  function initCards() {
    cards().forEach(card => {
      if (card.dataset.refaReady === 'true') return;
      card.dataset.refaReady = 'true';
      card.addEventListener('click', function () {
        const product = data[card.dataset.product] || {};
        if (product.url) window.location.href = product.url;
      });
    });
  }

  function initSizeControls() {
    document.querySelectorAll('.refa-size-btn').forEach(btn => {
      if (btn.dataset.refaReady === 'true') return;
      btn.dataset.refaReady = 'true';
      btn.addEventListener('click', () => {
        document.querySelectorAll('.refa-size-btn').forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (!grid) return;
        grid.classList.remove('size-large', 'size-small');
        if (btn.dataset.size === 'large') grid.classList.add('size-large');
        if (btn.dataset.size === 'small') grid.classList.add('size-small');
      });
    });
  }

  function initFilters() {
    filterControls().forEach(control => {
      if (control.dataset.refaReady === 'true') return;
      control.dataset.refaReady = 'true';
      control.addEventListener('click', () => {
        const filter = control.dataset.filter;
        filterControls().forEach(x => x.classList.toggle('active', x.dataset.filter === filter));
        let visible = 0;
        cards().forEach(card => {
          const show = filter === 'all' || (card.dataset.category || '').split(' ').includes(filter);
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });
        if (countEl) countEl.textContent = visible + (visible === 1 ? ' item' : ' items');
        const label = getFilterLabel(control);
        if (titleEl) titleEl.textContent = filter === 'all' ? titleEl.dataset.original || 'PRODUCTS' : label.toUpperCase();
        if (breadcrumbEl) breadcrumbEl.textContent = 'TOP / ' + (filter === 'all' ? titleEl?.textContent || 'PRODUCTS' : label.toUpperCase());
      });
    });
  }

  async function init() {
    if (titleEl) titleEl.dataset.original = titleEl.textContent;
    addCategoryCards();
    await hydrateCollectionProducts();
    initCards();
    initSizeControls();
    initFilters();
    updateFilterCounts();
  }

  init();
})();
